import React, { useState } from "react"
import { useCreateContactMutation } from "../../../../Redux/Apis/contactApi"
import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi"

function Contact() {
    const {data :{home: {contact : {data,name,caption}}}} = useGetSettingQuery()
    const [create,{isLoading : isCreateLoading}] = useCreateContactMutation()
    const [errorMsg, setErrorMsg] = useState(false)
    const [success, setSuccess] = useState(false)
    const [formState, setFormState] = useState({
        name: "",
        email: undefined,
        mobile: undefined,
        subject: "",
        body: ""
    })
    const handleChange = ({ target: { name, value },} ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e) => {
        e.preventDefault()
        const payload = await create(formState)
        if (payload?.error?.data === "sended!"){
            e.target.reset()
            setSuccess(true)
            setErrorMsg(false)
        }else{
            setSuccess(false)   
            const message = !payload?.error?.data ? '' : Array.isArray(payload?.error?.data.message) ? payload?.error?.data.message[0] : payload?.error?.data.message
            setErrorMsg(message)   
        }
        // await create(formState).unwrap().then(() => {
        //     e.target.reset()
        //     setSuccess(true)
        //     setErrorMsg(false)
        // }).catch((err) => {
        //     setSuccess(false)   
        //     const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
        //     setErrorMsg(message)   
        // })
        // try {
        //     await create(formState).unwrap()
        //     e.target.reset()
        //     setSuccess(true)
        //     setErrorMsg(false)
        // } catch (err){
        //     // console.log(err);
        //     setSuccess(false)   
        //     const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
        //     setErrorMsg(message)            
        // }
        
    }
    
    
    return ( 
        <div className="container-fluid bg-light overflow-hidden my-5 px-lg-0" id="contact">
            <div className="container quote px-lg-0">
                <div className="row g-0 mx-lg-0">
                    <div className="col-lg-6 ps-lg-0" style={{minHeight: "400px"}}>
                        <div className="position-relative h-100">
                            <img className="position-absolute img-fluid w-100 h-100" src={data.img_image} style={{objectFit: "cover"}} alt=""/>
                        </div>
                    </div>
                    <div className="col-lg-6 quote-text py-5 wow fadeIn" data-wow-delay="0.5s">
                        <div className="p-lg-5 pe-lg-0">
                            <div className="section-title text-start">
                                <h1 className="display-5 mb-4">{name}</h1>
                            </div>
                            <p className="mb-4 pb-2">{caption}</p>
                            {!success ?
                            <form onSubmit={onSubmit}>
                                <div className="row g-3">
                                    <div className="col-12 col-sm-6">
                                        <input type="text" className="form-control border-0" name="name" onChange={handleChange} placeholder="نام و نام خانوادگی" style={{height: "55px"}}/>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <input type="email" className="form-control border-0" name="email" onChange={handleChange} placeholder="آدرس ایمیل(اختیاری)" style={{height: "55px"}}/>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <input type="text" className="form-control border-0" name="mobile" onChange={handleChange} placeholder="شماره موبایل" style={{height: "55px"}}/>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <input type="text" className="form-control border-0" name="subject" onChange={handleChange} placeholder="موضوع پیام" style={{height: "55px"}}/>
                                    </div>
                                    <div className="col-12">
                                        <textarea className="form-control border-0" name="body" onChange={handleChange} placeholder="پیام شما"></textarea>
                                    </div>
                                    <div className="col-12">
                                        {data.mdl_message ?
                                            <button className="btn btn-primary w-100 py-3" disabled={isCreateLoading} type="submit">ارسال</button> 
                                            :
                                            <div className="btn btn-secondary w-100 py-3">غیر فعال</div>
                                        }
                                    </div>
                                    {errorMsg && <div className="alert alert-danger" role="alert">
                                        {errorMsg}
                                    </div>}
                                </div>
                            </form> :
                            <div className="alert alert-success" role="alert">
                                پیام شما با موفقیت ارسال گردید.
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Contact;